import NotFound from "../framework/pages/404";
import Help from "../pages/Help";
import Home from "../pages/Home";
import webRootContext from "./webrootcontext/WebRootContext";

// window.location.href Need to be based context root.
// Archetype will replace  path.

 
const navigation = [
  {
	to: webRootContext + "/",
	text: "",
	component: Help,
	displayOrder: 1,
	showInMenu: false,
	allowAccess: ["ALL"],
    needExact: true
  },
  {
	to: webRootContext + "/Help",
	text: "",
	component: Help,
	displayOrder: 1,
	showInMenu: false,
	allowAccess: ["ALL"],
    needExact: true
  },
  {
    to: "*",
    text: "404",
    component: NotFound,
    displayOrder: 11,
	showInMenu: false,
	allowAccess: ["ALL"],
    needExact: false
  }, 
  
 //The $webRootContext entry below seems to break everything after it.
 {
	to: webRootContext + "/",
	text: "",
	component: Home,
	allowAccess: ["ALL"],
	displayOrder: 12,
  }
];

export default navigation;